import "./style.scss";
import { ReactComponent as Sheild } from "../assets/sheild.svg";
import { ReactComponent as Standard } from "../assets/standard.svg";
import { ReactComponent as NoCancel } from "../assets/no_cancel.svg";
import { ReactComponent as Tick } from "../assets/tick2.svg";

import { ReactNode, useContext, useEffect, useState } from "react";
import Collapse from "../Collapse";
import { BookingInterface } from "context/BookingData";
import { useSearchParams } from "react-router-dom";

type InsuranceOption = {
	title: string;
	icon: ReactNode;
	price: number | undefined;
	perks: string[];
	priceSub: string;
	func: () => void;
};

const Insurance = ({ data }: any) => {
	const { updateBooking, fetchInsuranceData }: any =
		useContext(BookingInterface);
	const [searchParams, setSearchParams] = useSearchParams();

	const insurance = fetchInsuranceData?.data?.data?.data;
	const UpdateBooking = async (couponCode: string) => {
		updateBooking.mutate({
			COUPON_CODE: couponCode,
			IS_INSURANCE: "",
		});
		searchParams.set("coupon", couponCode);
		setSearchParams(searchParams, { replace: true });
	};
	const options = [
		{
			title: "Flexible",
			icon: <Sheild />,
			price: insurance?.flexible,
			perks: [
				"Free cancellation upto 24 hours from Check-In",
				"100% Full Refund when you cancel*",
				"Best option if you want flexibility",
			],
			priceSub: `Includes ${new Intl.NumberFormat("en-IN", {
				style: "currency",
				currency: "INR",
				maximumFractionDigits: 0,
			}).format(insurance?.insurance)} premium`,
			func: () => {
				updateBooking.mutate({
					COUPON_CODE: "",
					IS_INSURANCE: "Y",
				});
				searchParams.set("coupon", "");
				setSearchParams(searchParams, { replace: true });
			},
		},
		{
			title: "Standard",
			icon: <Standard />,
			price: insurance?.standard,
			perks: [
				"Our standard pricing and policy",
				"Cancellation according to <a href='/cancellation-policy'>our general policy</a>",
			],
			priceSub: "",
			func: () => {
				UpdateBooking("");
			},
		},
		{
			title: "No Cancellation",
			icon: <NoCancel />,
			price: insurance?.nocancel,
			perks: [
				"Best price, maximum discount",
				"No cancellations allowed after booking",
			],
			priceSub: `Save ${new Intl.NumberFormat("en-IN", {
				style: "currency",
				currency: "INR",
				maximumFractionDigits: 0,
			}).format(insurance?.discount)}*`,
			func: () => {
				UpdateBooking("NOCANCEL");
			},
		},
	];

	const [option, setOption] = useState<InsuranceOption | null>(options[1]);

	useEffect(() => {
		if (searchParams?.get("coupon") === "NOCANCEL") {
			setOption(options[2]);
		} else if (searchParams?.get("coupon") === "") {
			setOption(options[1]);
		} else {
			setOption(null);
		}
	}, [searchParams]);

	useEffect(() => {
		if (data?.INSURANCE_TOTAL) {
			setOption(options[0]);
		}
	}, [data]);

	return (
		<Collapse init={true} title="Choose your Booking Plan">
			<div className="insurance-wrapper">
				{options.map((e) => {
					return (
						<div
							className={`insurance-card-wrapper ${
								e.title !== "Standard" ? "flexible-card" : ""
							}`}
							style={{
								background: e?.title === option?.title ? "#F2FFF6" : "",
							}}
						>
							<div className="insurance-card-details">
								<div className="insurance-title">
									{e.icon} {e.title}
								</div>
								{e.perks.map((t) => (
									<div className="insurance-perk" key={t}>
										<Tick />{" "}
										<span dangerouslySetInnerHTML={{ __html: t }}></span>
									</div>
								))}
								{e.title === "Flexible" && (
									<span className="insurance-condition">
										* refund will not include the insurance premium
									</span>
								)}
								{e.title === "No Cancellation" && (
									<span className="insurance-condition">
										*subject to our base pricing
									</span>
								)}
							</div>
							<div className="insurance-btn-wrapper">
								<span className="insurance-price">
									{new Intl.NumberFormat("en-IN", {
										style: "currency",
										currency: "INR",
										maximumFractionDigits: 0,
									}).format(
										option?.title === e.title
											? e.title === "Flexible"
												? data.TOTAL_WITH_SERVICE_INSURANCE
												: data.TOTAL_AMOUNT_WITH_SERVICE
											: e.price,
									)}
									{e.title !== "Standard" && (
										<span
											style={{
												color: e.title === "No Cancellation" ? "#5AB081" : "",
											}}
										>
											{option?.title === "No Cancellation" &&
											e.title === "No Cancellation"
												? `Save ${new Intl.NumberFormat("en-IN", {
														style: "currency",
														currency: "INR",
														maximumFractionDigits: 0,
												  }).format(data?.DISCOUNT)}`
												: e.priceSub}
										</span>
									)}
								</span>

								<button
									onClick={() => {
										e.func();
										setOption(e);
									}}
									style={{ width: "fit-content", marginLeft: "auto" }}
									className={option?.title === e.title ? "active-plan" : ""}
								>
									{option?.title === e.title ? "Remove" : "Select"}
								</button>
							</div>
							{e.title === "Flexible" && (
								<span className="insurance-condition-mobile">
									* refund will not include the insurance premium
								</span>
							)}
							{e.title === "No Cancellation" && (
								<span className="insurance-condition-mobile">
									*subject to our base pricing
								</span>
							)}
						</div>
					);
				})}
			</div>
		</Collapse>
	);
};

export default Insurance;
